import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FireInsuranceAgent } from '@models/brokerage';
import { Store } from '@ngxs/store';
import { MatterDispatch } from '@state/matter';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { NavigationService } from 'src/app/shared/services/nav/nav.service';

@Component({
	selector: 'app-edit-fire-insurance-agent',
	templateUrl: './edit-fire-insurance-agent.component.html',
	standalone: false,
})
export class EditFireInsuranceAgentComponent {
	public matterId = this.store.selectSnapshot(SelectedMatter.id);
	public fireInsuranceCompany = this.store.selectSnapshot(
		SelectedMatter.fireInsuranceCompany,
	);
	public fireInsuranceAgent: FireInsuranceAgent;

	constructor(
		private router: Router,
		private route: ActivatedRoute,
		private store: Store,
		private navigationService: NavigationService,
		private matterDispatch: MatterDispatch,
	) {
		this.fireInsuranceAgent =
			this.router.getCurrentNavigation()?.extras?.state?.fireInsuranceAgent;

		if (!this.fireInsuranceAgent) {
			this.navigationService.goBack(this.route);
		}
	}

	_onSubmit(fireInsuranceAgent: FireInsuranceAgent) {
		this.matterDispatch.CreateFireInsuranceAgent(
			this.matterId,
			this.fireInsuranceCompany.id,
			fireInsuranceAgent,
		);
		this.navigationService.goBack(this.route);
	}

	_onCancel() {
		this.navigationService.goBack(this.route);
	}
}
